export const cancellationPolicies = (state = {}, action) => {
  switch (action.type) {
    case "LIST_CANCELLATION_POLICIES_REQUEST":
      return {
        ...state,
        loading: true,
        policies: null,
      };
    case "LIST_CANCELLATION_POLICIES_SUCCESS":
      return {
        ...state,
        loading: false,
        policies: action.payload,
      };
    case "LIST_CANCELLATION_POLICIES_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_CANCELLATION_POLICY_REQUEST":
      return {
        ...state,
        loading: true,
        policy: null,
      };
    case "VIEW_CANCELLATION_POLICY_SUCCESS":
      return {
        ...state,
        loading: false,
        policy: action.payload,
      };
    case "VIEW_CANCELLATION_POLICY_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_CANCELLATION_POLICY_REQUEST":
      return {
        ...state,
        loading: true,
        addResponse: null,
      };
    case "ADD_CANCELLATION_POLICY_SUCCESS":
      return {
        ...state,
        loading: false,
        addResponse: action.payload,
      };
    case "ADD_CANCELLATION_POLICY_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_CANCELLATION_POLICY_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_CANCELLATION_POLICY_SUCCESS":
      return {
        ...state,
        loading: false,
        updateResponse: action.payload,
      };
    case "UPDATE_CANCELLATION_POLICY_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "REMOVE_CANCELLATION_POLICY_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "REMOVE_CANCELLATION_POLICY_SUCCESS":
      return {
        ...state,
        loading: false,
        removedId: action.payload, // Store removed policy id if needed
      };
    case "REMOVE_CANCELLATION_POLICY_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
